const GET_CURRENT_USER = "GET_CURRENT_USER";
const SET_CURRENT_USER = "SET_CURRENT_USER";

const GET_CURRENT_USER_BY_TIME_INTERVAL = "GET_CURRENT_USER_BY_TIME_INTERVAL";

export
{
    GET_CURRENT_USER,
    SET_CURRENT_USER,
    GET_CURRENT_USER_BY_TIME_INTERVAL
};
